import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const PromptBox = ({ prompt }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(prompt);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <div className="mt-6 bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
      <div className="flex justify-between items-center px-4 py-2 bg-gray-100 border-b border-gray-200">
        <span className="text-xs font-bold text-brand-gray uppercase tracking-wider">
          Prompt de AI
        </span>
        <button 
          onClick={handleCopy}
          className="flex items-center gap-2 text-sm font-semibold text-brand-cyan hover:text-cyan-600 transition-colors"
        >
          {copied ? (
            <><SafeIcon icon={FiIcons.FiCheck} /> Copiado</>
          ) : (
            <><SafeIcon icon={FiIcons.FiCopy} /> Copiar</>
          )}
        </button>
      </div>
      <div className="p-4">
        <p className="text-brand-black font-medium text-sm leading-relaxed">
          "{prompt}"
        </p>
      </div>
    </div>
  );
};

export default PromptBox;